/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifactsdownloadagain2Inputs */

const en_artifactsdownloadagain2 = /** @type {(inputs: Artifactsdownloadagain2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`download again`)
};

const pt_artifactsdownloadagain2 = /** @type {(inputs: Artifactsdownloadagain2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`transferir novamente`)
};

/**
* | output |
* | --- |
* | "download again" |
*
* @param {Artifactsdownloadagain2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const artifactsdownloadagain2 = /** @type {((inputs?: Artifactsdownloadagain2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifactsdownloadagain2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_artifactsdownloadagain2(inputs)
	return pt_artifactsdownloadagain2(inputs)
});
export { artifactsdownloadagain2 as "artifactsDownloadAgain" }